import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { DatePipe, DecimalPipe } from "@angular/common";
import { saveAs } from 'file-saver';
import { DownloadFileService } from '../../shared/services/download-file.service';
import { ApiService } from '../../shared/services/api.service';
import { Urls } from '../../utils/urls';
import { CommonDataService } from "../../shared/services/common-data.service";
import { ExportExcelService } from "../../shared/services/export-excel.service";
// import * as moment from 'moment';
import { PAGE_SIZE, Please_select_From_Date_and_To_Date} from "@root/app.constant";
import { ToastrService } from "ngx-toastr";
// import { matPaginator } from "@angular/material";
import { MatPaginator } from '@angular/material/paginator';
import moment from 'moment';
// import { ReturnList } from 'src/app/Accessories/constants/general-constants';
@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent implements OnInit {
  activeTopicId = 0;

  topicList:any[] = [];

  topicListMap:{[key:string]: any[]} ={};
  
  data:any[] = [];

  assetCheck : boolean = false;

  today = new Date();

  range : { start: Date, end: Date} = { start : new Date(), end : new Date()};

  pageSize:number = PAGE_SIZE;

  pageIndex:number = 0;

  activePageDataChunk:any[] = [];

  digitalFactsheetData=[];

  digitalFactSheetTitle = "Digital Factsheet";

  factSheetTitie = "Factsheet";

  selectedYear!:string;

  filteredActivePageDataChunk!:any;

  yearList:any[] = [];

  filteredYearList:any[] = [];

  returnList:any[] = [];

  liveMessage = '';

  @ViewChild(MatPaginator, { static : false} ) paginator!: MatPaginator;

  length:any;

  previousPageIndex:any;
  currentPage:any = 1;
  // pageIndex;

  // pageSize;
  @ViewChildren('tabItem')
tabItems!: QueryList<ElementRef>;

  constructor(public downloadFileService: DownloadFileService, 
              private apiService: ApiService, 
              private commonDataService: CommonDataService,
              public exportExcel: ExportExcelService,
              private toastr: ToastrService,) { }

  ngOnInit() {
    this.getDownloadFiles();
    this.scrollTop();
    this.readDigitalFactsheet();
  }
  pageChanged(event: number): void {
    this.currentPage = event;
  }
  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getDownloadFiles = () => {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(Urls.getDocumentsByType, {type : 'downloads'}).subscribe(
      response => {
        if (response.data.documentList){
          this.topicList = response.data.documentList;
          this.setDigitalFactSheetAsTopic();

          /* Set "Digital Factsheet" as the first topic */
          // console.log('Topic list -->', this.topicList);
          // let firstElement = this.topicList.filter(item => item.topic === "Digital Factsheet");
          // console.log(this.topicList.splice(2, 1));
          // console.log('First element -->', firstElement);
          // this.topicList.unshift(firstElement[0]);
          // console.log('Topic list -->', this.topicList);
          
          this.setYearList();
          this.activePageDataChunk = this.topicList[0].returnList.slice(0, this.pageSize);
          // if (this.topicList[this.activeTopicId].topic === this.factSheetTitie) {
          //   this.activePageDataChunk = ReturnList.slice(0, this.pageSize);
          // }
          // else {
          //   this.activePageDataChunk = this.topicList[0].returnList.slice(0, this.pageSize);
          // }
          this.commonDataService.loaderStatus.next(false);
        }
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    )
  }

  setActiveTopic = (id:number) => {
    this.assetCheck = false;
    this.activeTopicId = id;
    this.activePageDataChunk = this.topicList[id].returnList.slice(0, this.pageSize);
    // if (this.topicList[this.activeTopicId].topic === this.factSheetTitie) {
    //   this.activePageDataChunk = ReturnList.slice(0, this.pageSize);
    // }
    // else {
    //   this.activePageDataChunk = this.topicList[id].returnList.slice(0, this.pageSize);
    // }
    this.setYearList();
    this.liveMessage = `${this.topicList[id].topic} loaded. ${this.activePageDataChunk.length} items available.`;
  }

  onTabKeydown(event: KeyboardEvent, index: number) {

  switch (event.key) {

    case 'ArrowDown':
      event.preventDefault();
      this.focusTab(index + 1);
      break;

    case 'ArrowUp':
      event.preventDefault();
      this.focusTab(index - 1);
      break;

    case 'Home':
      event.preventDefault();
      this.focusTab(0);
      break;

    case 'End':
      event.preventDefault();
      this.focusTab(this.topicList.length - 1);
      break;

    case 'Enter':
    case ' ':
      event.preventDefault();
      this.setActiveTopic(index);
      break;
  }
}

focusTab(index: number) {

  if (index < 0) {
    index = this.topicList.length - 1;
  }

  if (index >= this.topicList.length) {
    index = 0;
  }

  this.activeTopicId = index;

  setTimeout(() => {
    this.tabItems.get(index)?.nativeElement.focus();
  });
}

  setYearList() {
    this.yearList = [];
    this.yearList.push('All');
    this.getYearList();
  }

  getYearList() {
    this.returnList = this.topicList[this.activeTopicId].returnList
    let returnList = this.returnList;
    // let returnList;
    // if (this.topicList[this.activeTopicId].topic === this.factSheetTitie) {
    //   returnList = ReturnList;
    // }
    // else {
    //   returnList = this.topicList[this.activeTopicId].returnList;
    // }
    if (this.topicList[this.activeTopicId].topic === this.digitalFactSheetTitle || this.topicList[this.activeTopicId].topic === this.factSheetTitie) {
      returnList.forEach((object) => {
        this.yearList.push(Number(object.year));
      });
      this.filteredYearList = this.removeDuplicates(this.yearList);
      let numArray = this.filteredYearList;
      numArray.sort(function(a, b) {
        return b - a;
      });
    }
  }

  removeDuplicates(arr:any) {
    return arr.filter((item:any, index:any) => arr.indexOf(item) === index);
  }

  onYearChange = (event:any) => {
    if (this.selectedYear === 'All') {
      this.setActiveTopic(this.activeTopicId);
    }
    this.selectedYear = event;
    this.getFilteredDocumentList();
  }

  getFilteredDocumentList() {
    this.setActiveTopic(this.activeTopicId);
    if (this.selectedYear !== 'All') {
      this.returnList = this.topicList[this.activeTopicId].returnList.filter((item:any) => item.year === this.selectedYear);
    }
    else {
      this.returnList = this.topicList[this.activeTopicId].returnList;
    }
    let returnList = this.returnList;
    // let returnList;
    // if (this.topicList[this.activeTopicId].topic === this.factSheetTitie) {
    //   returnList = ReturnList;
    // }
    // else {
    //   returnList = this.topicList[this.activeTopicId].returnList;
    // }
    if (this.selectedYear !== 'All') {
      this.returnList = returnList.filter(item => item.year === this.selectedYear);
      this.activePageDataChunk = this.returnList.slice(0, this.pageSize);
    }
    else {
      this.returnList = returnList;
      this.activePageDataChunk = this.returnList.slice(0, this.pageSize);
    }
    this.paginator.firstPage();
    this.paginator.pageIndex = 0;
    this.liveMessage =
  `${this.activePageDataChunk.length} files loaded for ${this.selectedYear}.`;
  }

  viewFile = (path:string) => {
    window.open(path, '_blank');

  }

  public downloadFile(path:string, name:string){
    const fileName = path.split("/").pop();
    this.downloadFileService.export(path).subscribe(data => saveAs(data, fileName));
  }

  public assetAllocation(event: string){
   if(event === 'true'){
    this.assetCheck = true;
    this.readAssetAllocationData();
   }else{
    this.assetCheck = false;
   }
  }

  public readAssetAllocationData(){
    this.commonDataService.loaderStatus.next(true);
    const obj = { "fromDate": "",
                  "toDate" : ""
                }
    this.apiService.postData(Urls.readAssetAllocation, obj).subscribe(
      response => {
      this.data = response.data.list;
      this.commonDataService.loaderStatus.next(false);
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    )
  }

  public readDigitalFactsheet(){
    this.commonDataService.loaderStatus.next(true);
    const obj = { "year": ""}
    this.apiService.postData(Urls.readDigitalFactsheet, obj).subscribe(
      response => {
      if(response.status === 0){
          this.digitalFactsheetData =  response.data.digitalFactsheetReturnValue;
      }
      this.commonDataService.loaderStatus.next(false);
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    )
  }

  public setDigitalFactSheetAsTopic(){
   let factsheetIndex = 0; 
   for(let i=0; i<this.topicList.length; i++){
     const topic = this.topicList[i];
        if(topic.topic.toLowerCase() === "factsheet"){
          factsheetIndex = i;
          break;
        }
    }

    const digitalFactSheetTopic= {
      topic : this.digitalFactSheetTitle,
      returnList : this.digitalFactsheetData
    }
    this.topicList.splice(factsheetIndex+1, 0, digitalFactSheetTopic);
  }
 
  public downloadAssestAllocation(){
    const data = this.getFormatedData();
    this.exportExcel.exportAsExcelFile(data, `Assest_Allocation`)
  }

  private getFormatedData(): any[] {

    const datePipe = new DatePipe("en-US");
    const decimalPipe = new DecimalPipe("en-US");
    const data = JSON.parse(JSON.stringify(this.data));
    for (const row of data) {
      if (row.date) {
        row.date = datePipe.transform(row.date, "dd-MMM-yyyy");
      }
      if (row.netequity) {
        const netequity = decimalPipe.transform(row.netequity, "1.2-2");
        row.netequity = `${netequity}%`;
      }
      if (row.arbitrage) {
        const arbitrage = decimalPipe.transform(row.arbitrage, "1.2-2");
        row.arbitrage = `${arbitrage}%`;
      }
      if (row.debtandcash) {
        const debtandcash = decimalPipe.transform(row.debtandcash, "1.2-2");
        row.debtandcash = `${debtandcash}%`;
      }
    }
    return data;
  }

  public dateRangeSearch(){
    if(this.range.start === null || this.range.end === null){
      this.toastr.error(Please_select_From_Date_and_To_Date)
    }else{
      const obj = {
        fromDate : moment(this.range.start).format("YYYY-MM-DD"),
        toDate :  moment(this.range.end).format("YYYY-MM-DD")
      }
      this.commonDataService.loaderStatus.next(true);
      this.apiService.postData(Urls.readAssetAllocation, obj).subscribe(
        response => {
          this.data = response.data.list
          this.commonDataService.loaderStatus.next(false);
          this.resetDateRange()
        },
        error => {
          this.commonDataService.loaderStatus.next(false);
        }
      )
    }
  }

  onPageChanged(e:any, data:any) {
    this.length = e.left;
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.previousPageIndex = e.previousPageIndex;
    let firstCut = e.pageIndex * e.pageSize;
    let secondCut = firstCut + e.pageSize;
    this.activePageDataChunk = data.slice(firstCut, secondCut);
    // this.getYearList();
    this.liveMessage =
  `Page ${e.pageIndex + 1} loaded. ${this.activePageDataChunk.length} items available.`;
  setTimeout(() => {
  const firstViewButton = document.querySelector(
    '.file-item .view-img'
  ) as HTMLElement;

  firstViewButton?.focus();
});
  }

  public resetDateRange(){
    this.range.start = new Date();
    this.range.end = new Date();
  }
}
